import type { Control, FieldErrors } from "react-hook-form";
import type {
  FormFieldData,
  FormInputData
} from "../../../../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { FormFieldController } from "../../../../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { FormSection } from "../../../../../../BuildingBlocks/Forms/FormSection/FormSection";
import { isFieldError } from "../../../../../../BuildingBlocks/Forms/MantineFormFields/HelperText/utils/isFieldError";
import { ChangeablePricesField } from "../../../../SharedFields/ChangeablePricesField";
import { DELIVERY_FORM_HELP_TEXTS } from "../../DeliveryForm.constants";
import type { DeliveryFormFields } from "../../DeliveryForm.types";

interface DirectDeliveryFixedPriceFieldsProps {
  control: Control<DeliveryFormFields>;
  errors: FieldErrors<DeliveryFormFields>;
  formFieldData: FormFieldData<DeliveryFormFields>;
}

function DirectDeliveryFixedPriceFields({
  control,
  errors,
  formFieldData
}: DirectDeliveryFixedPriceFieldsProps) {
  return (
    <FormSection label="Konditionen Direktlieferung" mt="xl">
      <ChangeablePricesField
        className="WorkingPrices"
        control={control}
        error={
          isFieldError(errors.workingPrices) ? errors.workingPrices : undefined
        }
        helpText={DELIVERY_FORM_HELP_TEXTS.workingPrices}
        label={"Arbeitspreis inkl. Abgaben/Umlagen, exkl. MWSt.*"}
        name="workingPrices"
        unit="ct/kWh"
      />
      <FormFieldController
        control={control}
        data={
          formFieldData.electricityTax as FormInputData<
            DeliveryFormFields,
            "electricityTax"
          >
        }
        error={errors.electricityTax}
      />
    </FormSection>
  );
}

export { DirectDeliveryFixedPriceFields };
